import { render, staticRenderFns } from "./CChartRadarExample.vue?vue&type=template&id=44c696f2&"
import script from "./CChartRadarExample.vue?vue&type=script&lang=js&"
export * from "./CChartRadarExample.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports